import { VNode } from 'vue'

export function getRealDomTarget(node: VNode): HTMLElement | undefined {
  if (node.el) {
    // make sure it's a real dom
    if (node.el.getBoundingClientRect) {
      return node.el as HTMLElement
    }

    // otherwise assume it's the first el of a multi-root component(always a text with none dom attrs), try to get it's sibling
    if (node.el.nextElementSibling?.getBoundingClientRect) {
      return node.el.nextElementSibling
    }
  }

  // eslint-disable-next-line no-console
  console.warn('[delight spinner] cannot find out the target element for spinner, make sure you have passed some meaningful component to the default slot')

  return undefined
}
